import { put } from "../methods";
function updateUserCompanyPeers_default({ peerCollectionId, peerCollection }, headers = {}) {
  const config = {
    url: `backend/company-peers/user/peers/${peerCollectionId}`,
    headers,
    payload: peerCollection
  };
  return put(config);
}
export {
  updateUserCompanyPeers_default as default
};
